import { RoutesMounter } from '../../types';
import UserEdit from './pages/UserEdit';

export const mountUsersRoutes: RoutesMounter = ({ path }) => [
  {
    path,
    children: [{ path: ':id/edit', element: <UserEdit /> }],
  },
];
